import React from 'react'
import L from 'react-loadable'
import LoadingInline from '../loadingInline'

const Loading = () => (
    <div className="module loadableRoute">
        <LoadingInline />
    </div>
)

export default opts => L({
    loading: Loading,
    ...opts,
})


// WEBPACK FOOTER //
// ./src/app/components/features/share/loadable/loadableRoute.js